<template>
  <v-container>
    <v-text-field class="input-text-size" type="number"
      v-model.number="editedItem.reasonCode" label="Reason Code" />
    <v-text-field class="input-text-size"
    v-uppercase=globalSettingItem.conEverythingToCaps
      v-model="editedItem.description" label="Description" />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxReasonEditItem',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxReasonCode',
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('base/crud', ['item']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
  },
};
</script>
